webpackJsonp([58],{

/***/ 1122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_orderplan_js__ = __webpack_require__(1371);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35bfd37b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orderplan_vue__ = __webpack_require__(1616);
var normalizeComponent = __webpack_require__(509)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_orderplan_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35bfd37b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orderplan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_orderplan__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'orderrelease',
  data: function data() {
    return {
      search_text: '',
      search_date: null,
      active_page: 1,
      per_page: 100,
      is_load: false,
      dk_id: 0,
      dock_list: [],
      round: '',
      round_list: [],
      spl_id: 0,
      supplier_list: [],
      cycle_time: '',
      cycle_list: [],
      export_data: '',
      result_data: {
        pagination: [],
        count: 0
      }
    };
  },
  created: function created() {
    this.checkOAuth();
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.search_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      _this.getDockList();
      _this.getCycleList();
      // this.getReleaseRound()
      _this.getSupplierList();
      _this.activePage(_this.active_page);
      $('#select2-supplier').select2({
        placeholder: 'Supplier Code',
        allowClear: true,
        dropdownPosition: 'below'
      });
      $('#select2-supplier').on('select2:select', function (e) {
        _this.changeSupplier($('#select2-supplier').val());
      });
      $('#select2-supplier').on('select2:clear', function (e) {
        _this.changeSupplier('');
      });
      $('#select2-dock').select2({
        placeholder: 'Select Dock',
        allowClear: true,
        dropdownPosition: 'below'
      });
      $('#select2-dock').on('select2:select', function (e) {
        _this.changeDock($('#select2-dock').val());
      });
      $('#select2-dock').on('select2:clear', function (e) {
        _this.changeDock('');
      });
      $('#select2-cycle').select2({
        placeholder: 'Select Cycle',
        allowClear: true,
        dropdownPosition: 'below'
      });
      $('#select2-cycle').on('select2:select', function (e) {
        _this.changeCycle($('#select2-cycle').val());
      });
      $('#select2-cycle').on('select2:clear', function (e) {
        _this.changeCycle('');
      });
      $('#select2-round').select2({
        placeholder: 'Select Round',
        allowClear: true,
        dropdownPosition: 'below'
      });
      $('#select2-round').on('select2:select', function (e) {
        _this.changeRound($('#select2-round').val());
      });
      $('#select2-round').on('select2:clear', function (e) {
        _this.changeRound('');
      });
    }, 1000);
  },

  methods: {
    itemRender: function itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous';
      } else if (type === 'next') {
        return 'Next';
      }
      return originalElement;
    },
    activePage: function activePage(value) {
      this.active_page = value;
      this.getOrderRelease();
    },
    changeSupplier: function changeSupplier(id) {
      this.spl_id = id === '' ? 0 : id;
      this.activePage(this.active_page);
    },
    changeDock: function changeDock(id) {
      this.dk_id = id === '' ? 0 : id;
      this.activePage(this.active_page);
    },
    changeCycle: function changeCycle(id) {
      this.cycle_time = id === '' ? '' : id;
      this.activePage(this.active_page);
    },
    changeRound: function changeRound(id) {
      this.round = id === '' ? 0 : id;
      this.activePage(this.active_page);
    },
    getOrderRelease: function getOrderRelease() {
      var _this2 = this;

      this.is_load = true;
      var obj = {
        page: this.active_page,
        limit: this.per_page,
        date: this.search_date !== null ? this.dateFormatYMD(this.search_date) : '',
        dock: this.dk_id,
        round: this.round,
        supplier: this.spl_id,
        cycle: this.cycle_time,
        search: this.search_text
      };
      this.result_data.pagination = [];
      this.result_data.count = 0;
      this.header.params = obj;
      __WEBPACK_IMPORTED_MODULE_1__models_orderplan__["a" /* default */].getOrderRelease(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this2.result_data.pagination = result.data.pagination;
          _this2.result_data.count = result.data.count;
        } else {
          _this2.alert_msg('warning', 'An error occurred.', result.message);
        }
        _this2.is_load = false;
      }, function (error) {
        _this2.alert_msg('error', 'An error occurred.', error.message);
        _this2.is_load = false;
      });
    },
    exportData: function exportData() {
      var _this3 = this;

      this.export_list = [];
      var obj = {
        date: this.search_date !== null ? this.dateFormatYMD(this.search_date) : '',
        dock: this.dk_id,
        supplier: this.spl_id,
        cycle: this.cycle_time,
        search: this.search_text
      };
      this.header.params = obj;
      __WEBPACK_IMPORTED_MODULE_1__models_orderplan__["a" /* default */].getExportList(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this3.export_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data.export_list);
          setTimeout(function () {
            _this3.$refs.ExportText.submit();
          }, 1000);
        } else {
          _this3.alert_msg('warning', 'Order Release Export', result.message);
        }
      }, function (error) {
        _this3.alert_msg('error', 'Order Release Export', error.message);
      });
    },
    releaseProcess: function releaseProcess() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
        title: 'Order Release',
        text: 'You want to Process Order Release ?',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      }).then(function (result) {
        if (result.value) {
          if (_this4.search_date !== '' && _this4.cycle_time !== '') {
            var obj = {
              date: _this4.search_date !== null ? _this4.dateFormatYMD(_this4.search_date) : '',
              cycle: _this4.cycle_time
            };
            _this4.header.params = {};
            __WEBPACK_IMPORTED_MODULE_1__models_orderplan__["a" /* default */].releaseProcess(_this4.$store.state.URLHost, obj, _this4.header, function (result) {
              if (result.response === true) {
                // this.getReleaseRound()
                _this4.alert_msg('success', 'Process Order Release', result.message);
              } else {
                _this4.alert_msg('warning', 'Process Order Release.', result.message);
              }
            }, function (error) {
              _this4.alert_msg('error', 'An error occurred.', error.message);
            });
          } else {
            _this4.alert_msg('warning', 'Process Order Release.', 'Require input Date & Cycle');
          }
        }
      });
    },
    getReleaseRound: function getReleaseRound() {
      var _this5 = this;

      this.round_list = [];
      var obj = {
        date: this.search_date !== null ? this.dateFormatYMD(this.search_date) : '',
        cycle: this.cycle_time
      };
      this.round = '';
      this.header.params = obj;
      __WEBPACK_IMPORTED_MODULE_1__models_orderplan__["a" /* default */].getReleaseRound(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this5.round_list = result.data.round_list;
        }
      }, function (error) {
        _this5.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    rmOrder: function rmOrder(ord_id) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
        title: 'Remove Order',
        text: 'You want to remove this order ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel'
      }).then(function (result) {
        if (result.value) {
          $('.preloader').fadeIn();
          __WEBPACK_IMPORTED_MODULE_1__models_orderplan__["a" /* default */].rmOrder(_this6.$store.state.URLHost, ord_id, _this6.header, function (result) {
            if (result.response === true) {
              _this6.activePage(_this6.active_page);
              _this6.alert_msg('success', 'Remove Order', result.message);
              $('.preloader').fadeOut();
            } else {
              $('.preloader').fadeOut();
              _this6.activePage(_this6.active_page);
              _this6.alert_msg('warning', 'Remove Order', result.message);
            }
          }, function (error) {
            $('.preloader').fadeOut();
            _this6.alert_msg('error', 'Remove Order', error.message);
          });
        }
      });
    },
    getDockList: function getDockList() {
      var _this7 = this;

      this.dock_list = [];
      __WEBPACK_IMPORTED_MODULE_1__models_orderplan__["a" /* default */].getDockList(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this7.dock_list = result.data.dock_list;
        }
      }, function (error) {
        _this7.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    getCycleList: function getCycleList() {
      var _this8 = this;

      this.cycle_list = [];
      var obj = {
        date: this.search_date !== null ? this.dateFormatYMD(this.search_date) : '',
        dk_id: this.dk_id
      };
      this.header.params = obj;
      __WEBPACK_IMPORTED_MODULE_1__models_orderplan__["a" /* default */].getCycleList(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this8.cycle_list = result.data.cycle_list;
        }
      }, function (error) {
        _this8.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    getSupplierList: function getSupplierList() {
      var _this9 = this;

      this.supplier_list = [];
      __WEBPACK_IMPORTED_MODULE_1__models_orderplan__["a" /* default */].getSupplierList(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this9.supplier_list = result.data.supplier_list;
        } else {
          // this.alert_msg('warning', 'An error occurred.', result.message)
        }
      }, function (error) {
        _this9.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    goOrderPlanUpload: function goOrderPlanUpload() {
      this.$router.push({
        name: 'OrderPlanUpload',
        params: {
          active_page: this.active_page,
          dock: this.dock,
          supplier: this.supplier,
          part: this.part,
          is_auto: this.is_auto
        }
      });
    }
  }
});

/***/ }),

/***/ 1615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(511);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  searchPartStoreList: function searchPartStoreList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'orderplan/psflist', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPartlinkage: function getPartlinkage(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'orderplan/partlinkage', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },

  // Order Release
  getOrderRelease: function getOrderRelease(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'orderplan/orderrelease', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getExportList: function getExportList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'orderplan/exportlist', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },

  // Order Release
  releaseProcess: function releaseProcess(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'orderplan/releaseprocess', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getReleaseRound: function getReleaseRound(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'orderplan/releaseround', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  rmOrder: function rmOrder(URL, ord_id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.delete(URL + 'orderplan/' + ord_id, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getDockList: function getDockList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'orderplan/docklist', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getCycleList: function getCycleList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'orderplan/cyclelist', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getSupplierList: function getSupplierList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'orderplan/supplierlist', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
  //   getIssueDetailList(URL, cdcl_id, header, success, error) {
  //     Vue.axios.get(URL + 'orderplan/issuedetaillist/' + cdcl_id, header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
  //   addIssueDetailCycle(URL, obj, header, success, error) {
  //     Vue.axios.post(URL + 'orderplan/issuedetail', obj, header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
  //   // Order Release Export
  //   getIssueList(URL, header, success, error) {
  //     Vue.axios.get(URL + 'orderplan/issuelist', header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },

});

/***/ }),

/***/ 1616:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"d-lg-flex"},[_c('div',[_c('h3',{staticClass:"card-title"},[_c('span',{staticClass:"lstick d-inline-block align-middle"}),_vm._v(_vm._s(_vm.$route.meta.title_sub ? _vm.$route.meta.title_sub : _vm.$route.meta.title))]),_vm._v(" "),_c('h6',{staticClass:"card-subtitle"})])]),_vm._v(" "),_c('div',{staticClass:"contianer"},[_c('div',{staticClass:"row mt-3 mb-2"},[_c('div',{staticClass:"col-md-3 col-sm-12 col-xs-12 p-r-0 mb-2"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY',"placeholder":"Please Enter date"},on:{"change":function($event){_vm.activePage(1), _vm.getCycleList()}},model:{value:(_vm.search_date),callback:function ($$v) {_vm.search_date=$$v},expression:"search_date"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-12 col-xs-12 p-r-0 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dk_id),expression:"dk_id"}],staticClass:"form-select form-select-sm",staticStyle:{"width":"100%"},attrs:{"name":"active","id":"select2-dock"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dk_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.activePage(1), _vm.getCycleList()}]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("- Select Dock -")]),_vm._v(" "),_vm._l((_vm.dock_list),function(dock,index){return _c('option',{key:index,domProps:{"value":dock.id}},[_vm._v(_vm._s(dock.code + ' (' + dock.name + ')'))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-12 col-xs-12 p-r-0 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cycle_time),expression:"cycle_time"}],staticClass:"form-select form-select-sm",staticStyle:{"width":"100%"},attrs:{"name":"active","id":"select2-cycle"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cycle_time=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.activePage(1)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("- Select Cycle -")]),_vm._v(" "),_vm._l((_vm.cycle_list),function(cycle,index){return _c('option',{key:index,domProps:{"value":cycle.cdcl_time_h + ':' + cycle.cdcl_time_m}},[_vm._v(_vm._s(cycle.cdcl_time_h + ':' + cycle.cdcl_time_m))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-12 col-xs-12 p-r-0 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_id),expression:"spl_id"}],staticClass:"form-select form-select-sm",staticStyle:{"width":"100%"},attrs:{"name":"active","id":"select2-supplier"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.spl_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.activePage(1)}]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("- Select Supplier -")]),_vm._v(" "),_vm._l((_vm.supplier_list),function(spl,index){return _c('option',{key:index,domProps:{"value":spl.id}},[_vm._v(_vm._s(spl.code + ' (' + spl.name + ')'))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row mt-1 mb-2"},[_c('div',{staticClass:"col-md-3 col-sm-12 col-xs-12 p-r-0 mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search_text),expression:"search_text"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Enter keyword"},domProps:{"value":(_vm.search_text)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.activePage(1)},function($event){_vm.search_text === '' ? _vm.activePage(1) : ''}],"input":function($event){if($event.target.composing){ return; }_vm.search_text=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-sm-12 col-xs-12 p-r-0 mb-2 d-grid gap-2"},[_c('button',{staticClass:"btn btn-secondary btn-sm btn-sm-fix",attrs:{"type":"button"},on:{"click":function($event){_vm.active_page = 1
              _vm.getOrderRelease()}}},[_c('i',{staticClass:"fas fa-search mr-1"}),_vm._v(" Search\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-sm-12 col-xs-12 p-r-0 mb-2 d-grid gap-2"},[_c('button',{staticClass:"btn btn-info btn-sm btn-sm-fix",attrs:{"type":"button"},on:{"click":function($event){_vm.active_page = 1
              _vm.releaseProcess()}}},[_c('i',{staticClass:"fas fa-check mr-1"}),_vm._v(" Process\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-sm-12 col-xs-12 mb-2 d-grid gap-2"},[_c('button',{staticClass:"btn btn-warning btn-sm btn-sm-fix",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportData()}}},[_c('i',{staticClass:"fas fa-download mr-1"}),_vm._v(" Export")])]),_vm._v(" "),_c('div',{staticClass:"col-md-1 col-sm-12 col-xs-12 p-r-0 mb-2 text-right"},[_c('div',{staticClass:"d-inline-block mb-2"},[_c('button',{staticClass:"btn btn-primary btn-sm btn-sm-fix mr-4",attrs:{"type":"button"},on:{"click":function($event){return _vm.goOrderPlanUpload()}}},[_c('i',{staticClass:"fa fa-upload mr-1"}),_vm._v(" Order Plan Upload")])])]),_vm._v(" "),_c('form',{ref:"ExportText",attrs:{"action":_vm.$store.state.URLBase + '/static/text/order_release_export.php',"method":"post","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.export_data),expression:"export_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.export_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.export_data=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"table-responsive tableFixHead"},[_c('table',{staticClass:"table customize-table mb-0 v-middle"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[(_vm.is_load === true)?_c('td',{staticClass:"text-center",attrs:{"colspan":"14"}},[_c('i',{staticClass:"fas fa-sync-alt fa-spin fa-2x fa-fw"})]):_vm._e()]),_vm._v(" "),_vm._l((_vm.result_data.pagination),function(row,i){return _c('tr',{key:'row_' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.per_page * _vm.active_page - (_vm.per_page - i) + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.dateFormatDMY(row.ord_end_date)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.dk_code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.spl_code + ' (' + row.spl_name + ')'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.pr_id_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.pr_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.pr_name))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.cdcl_truck_no))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.cdcl_time_h + ':' + row.cdcl_time_m))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.ord_count))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.ord_adjust))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.ord_dayoff))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(row.ord_total))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                "+_vm._s(row.ord_release_round)+"                 \n                "),(row.ord_release_round == 0)?_c('a',{on:{"click":function($event){return _vm.rmOrder(row.ord_id)}}},[_vm._v(" | "),_c('i',{staticClass:"fa fa-trash"})]):_vm._e(),_vm._v(" "),(row.ord_release_round > 0)?_c('i',{staticClass:"text-success fa fa-check-circle"}):_vm._e()])])}),_vm._v(" "),(_vm.result_data.pagination.length < 1 && _vm.is_load === false)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"14"}},[_vm._v("No Data")])]):_vm._e()],2)])]),_vm._v(" "),(parseInt(_vm.result_data.count) > parseInt(_vm.per_page) && _vm.is_load === false)?_c('div',{staticClass:"text-end mt-3"},[_c('a-pagination',{staticStyle:{"cursor":"pointer"},attrs:{"pageSize":_vm.per_page,"total":_vm.result_data.count,"itemRender":_vm.itemRender},on:{"update:pageSize":function($event){_vm.per_page=$event},"update:page-size":function($event){_vm.per_page=$event},"change":_vm.activePage},model:{value:(_vm.active_page),callback:function ($$v) {_vm.active_page=$$v},expression:"active_page"}})],1):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{staticClass:"border-bottom border-top"},[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Date")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Dock")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Supplier")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Part ID")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Part number")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Part name")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Truck No")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Cycle")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Stock out")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Adjust")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Day off")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Order of Kanban")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-center"},[_vm._v("Round")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/58.f2e16a08a7e378b0c3d2.js